import cn from 'client/utils/cn';
import React, { Component } from 'react';

import Button from 'client/components/lego/button';
import Slider2 from 'client/components/slider2';

import './index.css';
import './slides.css';

import 'client/components/main-title/index.css';

import { ProfileData, PropsMainSlider } from 'client/bundles/types';

const b = cn('company-profile');
const bMainTitle = cn('main-title');

interface Props {
    profile: ProfileData;
    slider: PropsMainSlider[];
    stocksTeaserUrl: string;
}

class CompanyProfile extends Component<Props> {
    onContactClick = () => {
        const prefooter = document.getElementById('prefooter');

        if (prefooter) {
            prefooter.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }

    render() {
        const { profile: { title, text, businesses, about, contact, isShowStocks }, slider } = this.props;

        return (
            <div className={b()}>
                <div className={b('slider')}>
                    <Slider2 slider={slider} />
                </div>

                <div className={b('content')}>
                    <div className={b('company')}>
                        <article className={b('text')}>
                            <h2 className={bMainTitle()}>{title}</h2>

                            {text}
                        </article>

                        <div className={b('buttons')}>
                            {
                                about && about.title && about.url &&
                                    <Button
                                        className={b('button')}
                                        size="m"
                                        type="link"
                                        theme="raised"
                                        url={about.url}
                                        rel="noopener noreferrer"
                                        >
                                        {about.title}
                                    </Button>
                            }

                            {
                                businesses.title && businesses.url &&
                                    <Button
                                        className={b('button')}
                                        size="m"
                                        type="link"
                                        theme="raised"
                                        url={businesses.url}
                                        rel="noopener noreferrer"
                                        >
                                        {businesses.title}
                                    </Button>
                            }

                            {
                                contact.title &&
                                    <span className={b('button-contact')}>
                                        <Button
                                            className={b('button')}
                                            size="m"
                                            onClick={this.onContactClick}
                                            theme="pseudo"
                                            >
                                            {contact.title}
                                        </Button>
                                    </span>
                            }
                        </div>
                    </div>

                    {
                        isShowStocks &&
                        <div className={b('widgets')}>
                            <div className={b('stock-data')}>

                                <iframe
                                    className={b('stock-data-iframe')}
                                    src={this.props.stocksTeaserUrl}
                                    height="165"
                                    />
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default CompanyProfile;
